"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var AddMoreOptionsModal =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(AddMoreOptionsModal, _React$PureComponent);

  function AddMoreOptionsModal() {
    (0, _classCallCheck2.default)(this, AddMoreOptionsModal);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AddMoreOptionsModal).apply(this, arguments));
  }

  (0, _createClass2.default)(AddMoreOptionsModal, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "editor.form.config." + suffix;
    }
  }, {
    key: "getUnusedOtionsCheckboxes",
    value: function getUnusedOtionsCheckboxes(unusedOptions, updateSelectedOptions) {
      return unusedOptions.map(function (unusedOption, index) {
        return _react.default.createElement(_UICheckbox.default, {
          key: index,
          onChange: function onChange() {
            return updateSelectedOptions(unusedOption);
          }
        }, unusedOption);
      });
    }
  }, {
    key: "renderContacts",
    value: function renderContacts(formField) {
      var _this$props = this.props,
          allowPropertyEdits = _this$props.allowPropertyEdits,
          getPropertyEditorRoute = _this$props.getPropertyEditorRoute;

      if (!allowPropertyEdits) {
        return null;
      }

      return _react.default.createElement(_UILink.default, {
        external: true,
        href: getPropertyEditorRoute(formField.name, formField.propertyObjectType)
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('contacts')
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          allOptions = _this$props2.allOptions,
          unusedOptions = _this$props2.unusedOptions,
          addSelectedOptions = _this$props2.addSelectedOptions,
          updateSelectedOptions = _this$props2.updateSelectedOptions,
          closeModal = _this$props2.closeModal,
          formField = _this$props2.formField;
      var contacts = this.renderContacts(formField);
      var unusedOptionsCheckboxes = this.getUnusedOtionsCheckboxes(unusedOptions, updateSelectedOptions);
      return _react.default.createElement(_UIModal.default, {
        size: "auto"
      }, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement("h4", null, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('addOptions')
      }))), _react.default.createElement(_UIDialogCloseButton.default, {
        onClick: closeModal
      }), _react.default.createElement(_UIDialogBody.default, null, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('availableOptions')
      }), _react.default.createElement("div", {
        className: "unused-options-list"
      }, unusedOptionsCheckboxes), _react.default.createElement(_UIButton.default, {
        size: "small",
        use: "primary",
        onClick: function onClick() {
          return addSelectedOptions(allOptions);
        }
      }, _react.default.createElement(_FormattedMessage.default, {
        message: 'add'
      }))), _react.default.createElement(_UIDialogFooter.default, null, contacts ? _react.default.createElement(_Small.default, {
        use: "help"
      }, _react.default.createElement(_FormattedReactMessage.default, {
        message: this.langKey('doYouWantANewOption'),
        options: {
          contacts: contacts
        }
      })) : null));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        formField: _react.default.PropTypes.string.isRequired,
        allOptions: _react.default.PropTypes.array.isRequired,
        unusedOptions: _react.default.PropTypes.array.isRequired,
        addSelectedOptions: _react.default.PropTypes.func.isRequired,
        updateSelectedOptions: _react.default.PropTypes.func.isRequired,
        closeModal: _react.default.PropTypes.func.isRequired,
        getPropertyEditorRoute: _react.default.PropTypes.func.isRequired,
        allowPropertyEdits: _react.default.PropTypes.bool.isRequired
      };
    }
  }]);
  return AddMoreOptionsModal;
}(_react.default.PureComponent);

exports.default = AddMoreOptionsModal;
module.exports = exports.default;